import { render, staticRenderFns } from "./InternetHousePanel.vue?vue&type=template&id=12442213&"
import script from "./InternetHousePanel.vue?vue&type=script&lang=js&"
export * from "./InternetHousePanel.vue?vue&type=script&lang=js&"
import style0 from "./InternetHousePanel.vue?vue&type=style&index=0&id=12442213&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports